import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
    [ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].GET_WORKS_STAFF_PAYMENT_RATES_NORMS]: {
		url: '/company/:companyId/works_staff_payment_rates_norms/',
	},

	[ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].GET_WORKS_STAFF_PAYMENT_RATES_NORM]: {
		url: '/company/:companyId/works_staff_payment_rates_norms/:worksStaffPaymentRatesNormId/',
	},

	[ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].CREATE_WORKS_STAFF_PAYMENT_RATES_NORM]: {
		url: '/company/:companyId/works_staff_payment_rates_norms/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].PUT_WORKS_STAFF_PAYMENT_RATES_NORM]: {
		url: '/company/:companyId/works_staff_payment_rates_norms/:worksStaffPaymentRatesNormId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].PATCH_WORKS_STAFF_PAYMENT_RATES_NORM]: {
		url: '/company/:companyId/works_staff_payment_rates_norms/:worksStaffPaymentRatesNormId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	
	[ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].DELETE_WORKS_STAFF_PAYMENT_RATES_NORM]: {
		url: '/company/:companyId/works_staff_payment_rates_norms/:worksStaffPaymentRatesNormId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}